import * as React from 'react';
const Share = (props: any) => {
  const { fillColor = '#FFFFFF' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
      <path
        fill={fillColor}
        d="M15 18.125a2.212 2.212 0 0 1-1.623-.668 2.209 2.209 0 0 1-.669-1.624c0-.104.008-.211.025-.323.016-.111.041-.214.074-.308l-6.163-3.61c-.22.22-.47.391-.752.514a2.196 2.196 0 0 1-.892.186 2.21 2.21 0 0 1-1.624-.668A2.209 2.209 0 0 1 2.708 10c0-.636.223-1.178.668-1.624.446-.446.987-.669 1.624-.669.314 0 .611.062.892.185.281.124.532.295.752.514l6.163-3.609a1.658 1.658 0 0 1-.074-.308 2.207 2.207 0 0 1-.025-.323c0-.637.223-1.178.668-1.624A2.209 2.209 0 0 1 15 1.875c.636 0 1.177.223 1.623.668.446.446.67.986.67 1.623 0 .636-.224 1.177-.67 1.623-.445.446-.986.67-1.622.67-.314 0-.612-.062-.893-.186a2.46 2.46 0 0 1-.752-.513L7.192 9.369c.033.094.058.196.074.307a2.186 2.186 0 0 1 0 .646 1.659 1.659 0 0 1-.074.31l6.163 3.608c.22-.219.471-.39.752-.513.281-.124.579-.185.893-.185a2.21 2.21 0 0 1 1.623.668c.445.445.668.986.668 1.622 0 .637-.222 1.178-.668 1.624-.445.446-.986.669-1.622.669Z"
      />
    </svg>
  );
};
export default Share;
